import React from "react";
import { Paper, NativeSelect } from "@material-ui/core";
import * as S from '../formStyle';

function ComboBox({
    title,
    filterName,
    handleInputChange,
    valoresRespostas,
    isLoading,
    opcoesComboBox,
    ordem,
    conteudoOnChange,
    disabledList,
    componenteWidth
}) {
  const classes = S.useStyles();

  return (
    <>
        <label className={classes.label}>{title}</label>
        <Paper className={classes.medium} style={{width: `${componenteWidth}px` }} elevation={0}>
            <NativeSelect
                className={classes.input}
                style={{ paddingLeft: '10px' }}
                disabled={isLoading || disabledList[ordem]}
                name={filterName}
                onChange={(e) => {
                    handleInputChange(e, ordem, e.target.value, conteudoOnChange)
                }}
                value={valoresRespostas[ordem]}
            >
                {opcoesComboBox?.map((item) => (
                    <option key={item.Id} value={item.Id}>
                        {item.Informacao}
                    </option>
                ))}
            </NativeSelect>
        </Paper>
    </>
  );
}

export default ComboBox;
